import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { ButtonComponent, ButtonVariant } from "src/app/common/components/core/button/button.component";
import { DatePickerComponent } from "src/app/common/components/core/date-picker/date-picker.component";
import { DropdownComponent } from "src/app/common/components/core/dropdown/dropdown.component";
import { InputComponent } from "src/app/common/components/core/input/input.component";
import { DisciplineNumber } from "src/app/common/enums/discipline.enum";
import { PageHeaderComponent } from "src/app/features/page-header/page-header.component";
import { CommonModule } from "@angular/common";
import { PatientClient } from "src/app/common/services/patient.client";
import { Patient } from "src/app/common/interfaces/patient.interface";
import { firstValueFrom } from "rxjs";
import { PatientHeaderComponent } from "src/app/common/components/patient/patient-header.component";
import { Modes } from "src/app/common/enums/modes.enum";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DropdownItem } from "src/app/common/interfaces/dropdown-item.interface";
import { MatRadioModule } from "@angular/material/radio";
import { differenceInCalendarWeeks, format } from "date-fns";
import { AutoForecastClient } from "src/app/common/services/auto-forecast.client";
import { ApplyAutoForecastTemplate, AutoForecast, AutoForecastReviewRequest, AutoForecastReviewResponse, DisciplineMode, DisciplineModeWeekDayValue, ForecastTemplate, ForecastTemplateMode, TemplateOverrideValue } from "src/app/common/interfaces/auto-forecast.interface";
import { DisplayValue } from "src/app/common/components/labour-hours/labour-hours.component";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationModalComponent } from "src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component";
import { ChangesSaved, DateFormat, DialogMessageReviewUtility, ReviewRequiredMessage } from "src/app/common/constants/core-constants";
import { ActivatedRoute, Router } from "@angular/router";
import { PayorMethodology } from "src/app/common/enums/payor-methodology.enum";
import { AppConstants } from "src/app/common/constants/app-constants";
import { AutoForecastService } from "src/app/common/services/auto-forecast.service";
import { ForecastClient } from "src/app/common/services/forecast.client";
import { ChangeTracker } from "src/app/common/classes/change-tracker.class";
import { OpenCare } from "../facility-discipline-section/facility-discipline-section.component";
@Component({
  selector: "app-auto-forecast",
  templateUrl: "./auto-forecast.component.html",
  standalone: true,
  imports: [ButtonComponent, DropdownComponent, PageHeaderComponent, MatFormFieldModule, MatCheckboxModule, InputComponent, DatePickerComponent, CommonModule, PatientHeaderComponent, MatTooltipModule, MatRadioModule, ReactiveFormsModule, FormsModule],
  styleUrls: ["./auto-forecast.component.scss"],
})
export class AutoForecastComponent extends ChangeTracker implements OnInit {
  autoForecastForm!: FormGroup;
  payorMethodology = PayorMethodology;
  appConstants = AppConstants;
  lastEstDates: {
    PT: Date | null;
    OT: Date | null;
    ST: Date | null;
  } = {
    PT: null,
    OT: null,
    ST: null,
  };
  tempSelectedDisciplines: number[] = [];
  tempSelectedModes: { [disciplineId: number]: number[] } = {};
  forecastTemplateMode = ForecastTemplateMode;
  mode: ForecastTemplateMode = ForecastTemplateMode.Apply;
  buttonVariant = ButtonVariant;
  patientfacilityid!: number;
  templateId: string = "";
  args: any = {};
  isAdding: boolean = false;
  isAssign: boolean = true;
  createthroughCorpandFacility : boolean = false;
  methodologyId!: number;
  templateDropdownList!: DisplayValue<string>[];
  templateDropDownValues: DropdownItem[] = [];
  selectedDisciplines: number[] = [];
  upperSelectedDisciplines: number[] = [];
  selectedWeekdays: number[] = [];
  selectedModes: { [key: number]: number[] } = {};
  disciplinelist: any;
  id!: string;
  valueminutes!: number;
  patient!: Patient;
  autoforecastReviewResponse: AutoForecastReviewResponse | null = null;
  patientIdParam: string = "";
  title: string = "Auto Forecast";
  modes: any;
  Weekslist: { label: string; value: number }[] = [];
  readonly tooltip : string = `Choose a template from the dropdown and apply to resident's forecast`;
  weekordayoptions: { label: string; value: string; checked: boolean }[] = [];
  selectedValue: number = 1;
  numbers: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  planByDropdownItem: DropdownItem[] = [{ id: "1", name: "Minutes" }];
  autoforecast: AutoForecast =  {
    assignedvalue: {
      value: 0,
      weekdays: [],
      selecteddisciplinemodes: []
    },
    overriddenvalues: [],
    id: null,
    name: "",
    planbyid: 0,
    corpid: "",
    facilityid: null,
    selecteddisciplines: []
  };
  ptOpenDates: OpenCare[] = [];
  otOpenDates: OpenCare[] = [];
  stOpenDates: OpenCare[] = [];
  isSaveEnabled:boolean=false
  hundredthDay!: any;
  weeksFromToday!: number;
  isWeekdaysCheckboxClicked: boolean = false;
  isdaysCheckboxClicked: boolean = false;
  minDate: Date = new Date();
  headerData: any;
  get selectedOptionControl() {
    return this.autoForecastForm.get('selectedOptionControl');
  }
  constructor(
    private activatedRoute: ActivatedRoute,
    private forecastclient: ForecastClient,
    private patientClient: PatientClient,
    private autoforecastclient: AutoForecastClient,
    private autoForecastService: AutoForecastService,
    private dialog: MatDialog,
    private matDialog: MatDialog,
    private router: Router,
    private formBuilder:FormBuilder,
  ) {
    super();
  }
  async ngOnInit(): Promise<void> {
    this.mode = this.autoForecastService.selectedTemplateMode;
    const queryParams = await firstValueFrom(this.activatedRoute.queryParams);
    const routeParams = await firstValueFrom(this.activatedRoute.params);
    this.templateId = routeParams["templateId"];
    this.args.corpid = queryParams["corpId"];
    this.args.facilityid = queryParams["facilityId"];
    this.patientfacilityid = this.autoForecastService.selectedPatientFacilityId;
    this.autoForecastForm = this.formBuilder.group({
      name: new FormControl(null),
      planbyid: new FormControl(),
      startdate: new FormControl(new Date()),
      duration: new FormControl(),
      selectedDisciplines: new FormControl([]),
      assignedValue: new FormControl(),
      overriddenValues: new FormControl([]),
      selectedOptionControl : new FormControl(null),
    });
    this.disciplinelist = Object.keys(DisciplineNumber)
      .filter((key) => isNaN(Number(key)))
      .map((key) => ({
        label: key,
        value: DisciplineNumber[key as keyof typeof DisciplineNumber],
      }));
    this.modes = Object.keys(Modes)
      .filter((key) => isNaN(Number(key)))
      .map((key) => ({
        label: key,
        value: Modes[key as keyof typeof Modes],
      }));
    this.Weekslist = Object.keys(Weeks)
      .filter((key) => isNaN(Number(key)))
      .map((key) => ({
        label: key,
        value: Weeks[key as keyof typeof Weeks],
      }));
    this.weekordayoptions = Object.keys(ApplyToWeeksOrDays).map((key) => ({
      label: ApplyToWeeksOrDays[key as keyof typeof ApplyToWeeksOrDays],
      value: key,
      checked: false,
    }));
    if (this.mode === ForecastTemplateMode.Apply) {
      this.patientIdParam = this.autoForecastService.selectedPatientId;
      this.methodologyId = this.autoForecastService.patientMethodologyId;
      this.lastEstDates = this.autoForecastService.patientLastEstDates;
      this.getPatientDetails();
      this.getAllTemplatelist();
    }
    if (this.mode === ForecastTemplateMode.AddOrEdit) {
      if (this.templateId !== "add") {
        this.autoforecastclient.getAutoForecastTemplateById(this.templateId).subscribe((response) => {
          this.autoforecast = response;
          this.initializeTemplateFormValues(response);
          this.patchTemplateValues(response);
        });
      }
      this.autoForecastForm.get("name")?.addValidators(Validators.required)
      this.autoForecastForm?.updateValueAndValidity();
    } 
    this.initializeFormValues();
    this.autoForecastForm.markAsPristine();
    this.formGroup.registerControl(
      "autoForecastForm",
      this.autoForecastForm
    );
  }

  async fetchHundredthDay(): Promise<void> {
    try{
      const response = await firstValueFrom(this.forecastclient.getPatientMedicare100thday(this.patientfacilityid));  
      if (response) {
        this.hundredthDay = new Date(response);
        this.weeksFromToday = differenceInCalendarWeeks(this.hundredthDay, new Date());
      } else {
        this.hundredthDay = null;
        this.weeksFromToday = -1;
      }
    }catch (err: any) {
      this.dialog.open(ConfirmationModalComponent, {
          data: {
            title: "Error",
            message: (err as any)?.error,
            buttonText: "OK",
            hideCancelButton: true,
            isError: true,
          },
        });
    }
  }

  onassignvaluechange(value: any, disciplineid: number, modeid: number, weekid: number) {
    this.isSaveEnabled=true
    const controlName = this.getFormControlName(weekid, disciplineid, modeid);
    this.autoForecastForm.get(controlName)?.enable();
    const newValue = this.autoForecastForm.get(controlName)?.value ?? 0;
    if (!this.autoforecast) return;
    if (!this.autoforecast.overriddenvalues) {
      this.autoforecast.overriddenvalues = [];
    }
    const disciplinemode: DisciplineMode = {
      disciplineid,
      modeid,
    };
    const existingIndex = this.autoforecast.overriddenvalues.findIndex((entry) => entry.weekdayid === weekid && entry.disciplinemode.disciplineid === disciplineid && entry.disciplinemode.modeid === modeid);
    if (existingIndex > -1) {
      this.autoforecast.overriddenvalues[existingIndex].value = newValue;
    } else {
      this.autoforecast.overriddenvalues.push({
        weekdayid: weekid,
        disciplinemode: disciplinemode,
        value: newValue,
      });
    }
    this.formGroup.markAsDirty();
  }

  getFormControlName(week: number, discipline: number, mode: number): string {
    return `assignedValue_${week}_${discipline}_${mode}`;
  }

  assignedValue(){
    this.isSaveEnabled=true;
    this.selectedDisciplines = [...this.tempSelectedDisciplines];
    this.selectedModes = JSON.parse(JSON.stringify(this.tempSelectedModes));
    this.validationcheck();
  }

  validationcheck(){
    if(this.autoForecastForm.get("assignedValue")?.value && this.selectedWeekdays.length>0 ){
      this.isAssign = false;
    }else{
      this.isAssign = true;
    }
  }

  Assigncontrols(event: any): void {
    this.assignedValue();
    this.resetControls();
      this.isAssign = true;
      this.isSaveEnabled=true;
    if (this.autoforecast) {
      this.autoforecast.overriddenvalues = [];
    }
    this.valueminutes = this.autoForecastForm.get("assignedValue")?.value ?? 0;
    this.selectedDisciplines.forEach((discipline: number) => {
      if (!this.selectedModes[discipline]) return;
      this.selectedModes[discipline].forEach((mode: number) => {
        this.selectedWeekdays.forEach((week: number) => {
          const controlName = this.getFormControlName(week, discipline, mode);
          if (!this.autoForecastForm.get(controlName)) {
            this.autoForecastForm.addControl(controlName, new FormControl(event.value ?? 0));
          } else {
            this.autoForecastForm.get(controlName)?.setValue(this.valueminutes);
            this.autoForecastForm.get(controlName)?.enable();
          }
        });
      });
    });
    this.autoForecastForm.markAsDirty();
  }

  hasOpenTherapyEpisode(code: string): boolean {
    return this.headerData?.opentherapyepisode?.includes(`${code} (`);
  }

  private resetControls(){
    this.disciplinelist.forEach((discipline: { value: any }) => {
      this.modes.forEach((mode: { value: any }) => {
        this.Weekslist.forEach((week) => {
          const controlName = this.getFormControlName(week.value, discipline.value, mode.value);
          const control = this.autoForecastForm.get(controlName);
          if (
            this.selectedDisciplines?.includes(discipline.value) &&
            this.selectedModes[discipline.value]?.includes(mode.value) &&
            this.selectedWeekdays?.includes(week.value)
          ) {
          if (control !== null && control !== undefined) {
            control.enable();
          }
            return;
          }
          if (control !== null && control !== undefined) {
            // control.disable();
            control.reset();
          }
        });
      });
    });
  }

  private initializeFormValues(): void {
    this.disciplinelist.forEach((discipline: { value: any }) => {
      this.modes.forEach((mode: { value: any }) => {
        this.Weekslist.forEach((week) => {
          const controlName = this.getFormControlName(week.value, discipline.value, mode.value);
          if (!this.autoForecastForm.get(controlName)) {
            this.autoForecastForm.addControl(controlName, new FormControl({ value: "", disabled: false }, [Validators.min(0), Validators.max(999)]));
          }
        });
      });
    });
    if (this.autoforecast != null && this.autoforecast != undefined) {
      this.initializeTemplateFormValues(this.autoforecast);
    }
  }

  private initializeTemplateFormValues(autoForecast: AutoForecast): void {
    if(autoForecast === null || autoForecast===undefined) return ;
    this.autoForecastForm.patchValue({
      name: autoForecast?.name || null,
      planbyid: autoForecast?.planbyid || null,
      selectedDisciplines: autoForecast?.selecteddisciplines || [],
      assignedValue: autoForecast?.assignedvalue.value,
      overriddenValues: autoForecast?.overriddenvalues || [],
    });
  }

  private patchTemplateValues(autoForecast: AutoForecast) {
    if(autoForecast === null || autoForecast===undefined) return ;
    this.valueminutes = autoForecast.assignedvalue.value ?? 0;
    if(this.valueminutes){
      this.isAssign = true;
    }
    this.selectedDisciplines = autoForecast.selecteddisciplines;
    this.selectedModes = autoForecast.assignedvalue.selecteddisciplinemodes.reduce((acc: { [key: number]: number[] }, curr) => {
      if (!acc[curr.disciplineid]) {
        acc[curr.disciplineid] = [];
      }
      acc[curr.disciplineid].push(curr.modeid);
      return acc;
    }, {});
    this.tempSelectedDisciplines = [...this.selectedDisciplines];
    this.tempSelectedModes = { ...this.selectedModes };
    this.selectedWeekdays = autoForecast.assignedvalue.weekdays;
    this.oncheckconditionbasedondays(this.selectedWeekdays);
    const baseValue = autoForecast.assignedvalue.value;
    const overriddenValues = autoForecast.overriddenvalues || [];
    this.selectedDisciplines.forEach((discipline) => {
      if (!this.selectedModes[discipline]) return;
      this.selectedModes[discipline].forEach((mode) => {
        this.selectedWeekdays.forEach((week) => {
          const controlName = `assignedValue_${week}_${discipline}_${mode}`;
          const override = overriddenValues.find((ov) => ov.weekdayid === week && ov.disciplinemode.disciplineid === discipline && ov.disciplinemode.modeid === mode);
          const valueToAssign = override ? override.value : baseValue;
          if (!this.autoForecastForm.get(controlName)) {
            this.autoForecastForm.addControl(controlName, new FormControl(valueToAssign));
          } else {
            this.autoForecastForm.get(controlName)?.enable();
            this.autoForecastForm.get(controlName)?.setValue(valueToAssign);
          }
        });
      });
    });
    this.resetControls();
  }

  onValueChange(field: string, event: any): void {
    this.isSaveEnabled=true;
    const newValue = event?.value !== undefined ? event.value : event;
    this.autoForecastForm.patchValue({ [field]: newValue });
  }

  oncheckconditionbasedondays(selectedWeekdays: number[]) {
    const requiredWeekdays = [2, 3, 4, 5, 6]; 
    const requiredAllDays = [1, 2, 3, 4, 5, 6, 7];
    const allWeekdaysSelected = selectedWeekdays.length === requiredWeekdays.length && requiredWeekdays.every(day => selectedWeekdays.includes(day));
    const allDaysSelected = requiredAllDays.every(day => selectedWeekdays.includes(day));
    if (allDaysSelected) {
      this.selectedOptionControl?.setValue("days");
    } else if (allWeekdaysSelected) {
      this.selectedOptionControl?.setValue("weeks");
    } else {
      this.selectedOptionControl?.setValue(null);
    }
  }

  onDisciplineChange(disciplineValue: number, checked: boolean) {
    this.isSaveEnabled=true;
    if (checked) {
      if (!this.selectedDisciplines.includes(disciplineValue)) {
        this.selectedDisciplines.push(disciplineValue);
      }
    } else {
      this.selectedDisciplines = this.selectedDisciplines.filter((d) => d !== disciplineValue);

      if (disciplineValue === this.disciplinelist) {
        this.upperSelectedDisciplines.push(disciplineValue);
      }

      delete this.tempSelectedModes[disciplineValue];
    }
    this.tempSelectedDisciplines = [...this.selectedDisciplines];
    this.validationcheck();
  }

  onDisciplineChangeBasedonMode(disciplineValue: number, checked: boolean) {
    this.isSaveEnabled=true;
    if (checked) {
      if (!this.selectedDisciplines.includes(disciplineValue)) {
        this.selectedDisciplines.push(disciplineValue);
      }
    } else {
      this.selectedDisciplines = this.selectedDisciplines.filter((d) => d !== disciplineValue);
      this.tempSelectedModes[disciplineValue] = [];
    }
    this.tempSelectedDisciplines = [...this.selectedDisciplines];
    this.autoforecast.assignedvalue.selecteddisciplinemodes = Object.entries(this.selectedModes).flatMap(([disciplineid, modeIds]) => (modeIds as number[]).map((modeid) => ({ disciplineid: +disciplineid, modeid })));
    this.validationcheck();
  }
  isDisciplineAndModeSelected(disciplineValue: number, modeValue: number): boolean {
    return this.selectedDisciplines.includes(disciplineValue) && 
           this.selectedModes[disciplineValue]?.includes(modeValue);
  }
  
  onModeChange(disciplineValue: number, modeValue: number, checked: boolean) {
    if (!this.tempSelectedModes[disciplineValue]) {
      this.tempSelectedModes[disciplineValue] = [];
    }
    this.isSaveEnabled=true;
    if (checked) {
      if (!this.tempSelectedModes[disciplineValue].includes(modeValue)) {
        this.tempSelectedModes[disciplineValue].push(modeValue);
      }
      if (!this.tempSelectedDisciplines.includes(disciplineValue)) {
        this.tempSelectedDisciplines.push(disciplineValue);
      }
    } else {
      this.tempSelectedModes[disciplineValue] = this.tempSelectedModes[disciplineValue].filter(m => m !== modeValue);

      if (this.tempSelectedModes[disciplineValue].length === 0) {
        this.selectedDisciplines = this.selectedDisciplines.filter(d => d !== disciplineValue);
        delete this.tempSelectedModes[disciplineValue];
      }
    }
    this.tempSelectedDisciplines = [...this.selectedDisciplines];
    this.validationcheck();
  }

  onTemplateSelect(event: any) {
    this.id = event.value;
    this.autoforecastclient.getAutoForecastTemplateById(this.id).subscribe((response) => {
      this.autoforecast = response;
      if (response.selecteddisciplines) {
        this.tempSelectedDisciplines = [...response.selecteddisciplines];
      }
      if (response.assignedvalue?.selecteddisciplinemodes) {
        response.assignedvalue.selecteddisciplinemodes.forEach(response => {
          const disciplineId = response.disciplineid ?? response?.disciplineid;
          const modeId = response.modeid ?? response?.modeid;
          if (disciplineId != null && modeId != null) {
            if (!this.tempSelectedModes[disciplineId]) {
              this.tempSelectedModes[disciplineId] = [];
            }
            if (!this.tempSelectedModes[disciplineId].includes(modeId)) {
              this.tempSelectedModes[disciplineId].push(modeId);
            }
          }
        });
      }      
      this.patchTemplateValues(response);
      this.initializeTemplateFormValues(response);
      this.formGroup.markAsDirty();
    });
    if(this.patientfacilityid){
      this.fetchHundredthDay();
    }
    this.isAssign = true;
  }
  async getAllTemplatelist() {
    this.templateDropdownList = await firstValueFrom(this.autoforecastclient.getAutoForecastDropdownlist(this.args.facilityid));
    if (!this.templateDropdownList || this.templateDropdownList.length === 0) {
      this.templateDropDownValues = [{ id: "1", name: AppConstants.NoneAvailable }];
    } else {
      this.templateDropdownList.forEach((template) => {
        this.templateDropDownValues.push({
          id: template.value,
          name: template.display,
        });
      });
    }
  }
  async getPatientDetails() {
    if (this.patientIdParam) {
      this.patient = await firstValueFrom(this.patientClient.getPatient(this.patientIdParam));
      this.title += `:${this.patient?.lastname}, ${this.patient?.firstname}`;
      if(this.patient.id){
        this.headerData = await firstValueFrom(this.patientClient.getHeaderInfo(this.patient.id));
        this.parseOpenTherapyEpisode(this.headerData?.opentherapyepisode);
      }
    }
  }

  OnWeekdayschanged(value: string) {
    this.isSaveEnabled=true;
    const control = this.selectedOptionControl;
    if (!control) {
      return; 
    }
    if (control.value === value) {
      control.setValue(null);
      this.clearSelection(value);
    } else {
      control.setValue(value);
      if (value === "weeks") {
        this.selectedWeekdays = this.Weekslist
          .filter(item => item.value >= Weeks.Mon && item.value <= Weeks.Fri)
          .map(item => item.value);
      } else if (value === "days") {
        this.selectedWeekdays = this.Weekslist.map(item => item.value);
      }
    }
    this.validationcheck()
  }

  clearSelection(value: string) {
    if (value === 'weeks') {
      this.selectedWeekdays = this.selectedWeekdays.filter(
        day => day < Weeks.Mon || day > Weeks.Fri
      );
    } else if (value === 'days') {
      this.selectedWeekdays = [];
    }
    this.isAssign = false;
  }

  override async saveAndContinue(): Promise<void> {
    if (this.mode === ForecastTemplateMode.AddOrEdit) {
    await this.onSave(false);
    }
    if (this.mode === ForecastTemplateMode.Apply) {
      await this.onApply(false);
    }
  }
  async onSave(showModal: boolean = true): Promise<void> {
    if (!this.autoForecastForm.valid) {
      return;
    }
    this.isAdding = this.activatedRoute.snapshot.url.map((segment) => segment.path).includes("add");
    const autoForecastData: AutoForecast = {
      id: null,
      name: this.autoForecastForm.get("name")?.value ?? "",
      planbyid: this.autoForecastForm.get("planbyid")?.value || 1,
      corpid: this.args.corpid,
      facilityid: this.args.facilityid,
      selecteddisciplines: this.selectedDisciplines,
      overriddenvalues: this.parseOverridenValuesIntoDiscipline(this.autoforecast?.overriddenvalues || 0) ?? [],
      assignedvalue: {
        value: this.valueminutes ,
        weekdays: this.selectedWeekdays,
        selecteddisciplinemodes: this.selectedDisciplines.flatMap((discipline: number) =>
          (this.selectedModes[discipline] || []).map((modeid: number) => ({
            disciplineid: discipline,
            modeid: modeid,
          }))
        ),
      },
    };
    if (!this.isAdding) {
      autoForecastData.id = this.autoforecast?.id;
    }
    try {
      await firstValueFrom(
        this.isAdding
          ? this.autoforecastclient.addPatientAutoForecastTemplate(autoForecastData)
          : this.autoforecastclient.editPatientAutoForecastTemplate(autoForecastData)
      );
 
      this.autoForecastForm.markAsPristine();
      
      if (showModal) {
        this.dialog.open(ConfirmationModalComponent, { data: ChangesSaved })
          .afterClosed()
          .subscribe(() => {
            this.navigateAfterSave();
          });
      } else {
        this.navigateAfterSave();
      }
    } catch (err: any) {
      this.dialog.open(ConfirmationModalComponent, {
          data: {
            title: "Error",
            message: (err as any)?.error,
            buttonText: "OK",
            hideCancelButton: true,
            isError: true,
          },
        });
    }
  }

  private navigateAfterSave(): void {
    const facilityId = this.args.facilityid;
    if (facilityId == null || facilityId == undefined) {
      this.router.navigate([`/corporation/${this.args.corpid}/settings`], {
        queryParams: { view: "forecast-template" },
      });
    } else {
      this.router.navigate([`/facility/${facilityId}/payors/forecasttemplate`]);
    }
  }

  async onApply(showModal: boolean = true) {
    const startDate = this.autoForecastForm.get("startdate")?.value;
    const formattedStartDate = format(startDate, DateFormat);
    const autoForecastReviewRequest: AutoForecastReviewRequest = {
      patientId: this.patientIdParam,
      facilityId: this.patient?.facilityid,
      disciplineIds: this.selectedDisciplines,
      startDate: formattedStartDate,
      durationInWeeks: this.autoForecastForm.get("duration")?.value ? this.autoForecastForm.get("duration")?.value : 1,
      weekdays: this.selectedWeekdays,
    };
    const autoforecastTemplateRequest: ApplyAutoForecastTemplate = {
      patientid: this.patientIdParam,
      facilityid: this.patient.facilityid,
      patientfacilityid: this.patientfacilityid,
      planbyid: this.autoForecastForm.get("planbyid")?.value ? this.autoForecastForm.get("planbyid")?.value : 1,
      startDate: formattedStartDate,
      duration: this.autoForecastForm.get("duration")?.value ? this.autoForecastForm.get("duration")?.value : 1,
      forecastOverridenValues: this.parseOverridenValuesIntoDisciplineWeekDayValue(this.autoforecast?.overriddenvalues ?? 0) ?? [],
      assignedValue: {
        value: this.valueminutes ? this.valueminutes: 0,
        weekdays: this.selectedWeekdays,
        selecteddisciplinemodes: this.selectedDisciplines.flatMap((discipline: number) =>
          (this.selectedModes[discipline] || []).map((modeid: number) => ({
            disciplineid: discipline,
            modeid: modeid,
          }))
        ),
      },
    };
    try {
      this.autoforecastReviewResponse = await firstValueFrom(
        this.autoforecastclient.reviewBeforeApplyTemplate(autoForecastReviewRequest)
      );
      this.autoForecastForm.markAsPristine();
      if (this.autoforecastReviewResponse.isReviewRequired) {
        const confirmed = await firstValueFrom(
          this.dialog
            .open(ConfirmationModalComponent, {
              data: {
                ...DialogMessageReviewUtility("Review", "Required", this.autoforecastReviewResponse),
                note: ReviewRequiredMessage,
              },
            })
            .afterClosed()
        );
        if (confirmed) {
          await this.Applychanges(autoforecastTemplateRequest);
        }
      } else {
        await this.Applychanges(autoforecastTemplateRequest);
      }
    } catch (err) {
      this.matDialog.open(ConfirmationModalComponent, {
        data: {
          title: "Error",
          message: (err as any)?.error,
          buttonText: "OK",
          hideCancelButton: true,
          isError: true,
        },
      });
    }
  }

  onCancel() {
    history.back()
  }
  parseOverridenValuesIntoDisciplineWeekDayValue(overrides: TemplateOverrideValue[]): DisciplineModeWeekDayValue[] {
    const res: DisciplineModeWeekDayValue[] = [];
     if (!overrides || !Array.isArray(overrides)) {
      return [];
    }
    overrides.forEach((overrideValue) => {
      let val: DisciplineModeWeekDayValue = {
        modeid: overrideValue.disciplinemode.modeid,
        disciplineid: overrideValue.disciplinemode.disciplineid,
        weekdayid: overrideValue.weekdayid,
        value: overrideValue.value ? overrideValue.value : 0,
      };
      res.push(val);
    });
    return res;
  }

  parseOverridenValuesIntoDiscipline(overrides: TemplateOverrideValue[] | undefined | null): TemplateOverrideValue[] {
    const res: TemplateOverrideValue[] = [];
    if (!overrides || !Array.isArray(overrides)) {
      return [];
    }
    overrides.forEach((overrideValue) => {
      let val: TemplateOverrideValue = {
        disciplinemode: overrideValue.disciplinemode,
        weekdayid: overrideValue.weekdayid,
        value:overrideValue.value ? overrideValue.value : 0,
      };
      res.push(val);
    });
    return res;
  }

  Applychanges(autoforecastTemplateRequest: ApplyAutoForecastTemplate) {
    this.autoforecastclient.applyAutoforecastTemplate(autoforecastTemplateRequest).subscribe({
      next: (res) => {
        this.matDialog
          .open(ConfirmationModalComponent, { data: ChangesSaved })
          .afterClosed()
          .subscribe(() => {
            this.autoForecastForm.markAsPristine();
            this.router.navigate(["/patient", this.patient.facilityid, "profile", this.patient.id, "forecast"]);
          });
      },
      error: (err) => {
        this.matDialog.open(ConfirmationModalComponent, {
          data: {
            title: "Error",
            message: (err as any)?.error,
            buttonText: "OK",
            hideCancelButton: true,
            isError: true,
          },
        });
      },
    });
  }

  OnselectWeeklist(value: number, event: MatCheckboxChange) {
    this.isSaveEnabled=true
    if (event.checked) {
      this.selectedWeekdays.push(value);
    } else {
      this.selectedWeekdays = this.selectedWeekdays.filter((day) => day !== value);
    }
    this.oncheckconditionbasedondays(this.selectedWeekdays);
    this.validationcheck();
  }
  
  private parseOpenTherapyEpisode(opentherapyepisode: string | null): void {
    if (!opentherapyepisode) return;

    const disciplineAbbrs = opentherapyepisode.split('|').map(part => part.trim().split(' ')[0])  .filter(Boolean);
    this.disciplinelist = Object.keys(DisciplineNumber).filter((key) => isNaN(Number(key)))
    .map((key) => ({
      label: key,
      value: DisciplineNumber[key as keyof typeof DisciplineNumber],
      code: key 
    }));
    this.autoForecastForm.get('selectedDisciplines')?.setValue(this.disciplinelist);
    this.hasOpenTherapyEpisode(this.disciplinelist);
  }

}
export enum Weeks {
  Sun = 1,
  Mon,
  Tue,
  Wed,
  Thur,
  Fri,
  Sat,
}
export enum ApplyToWeeksOrDays {
  weeks = "Apply to weekdays",
  days = "Apply to all days",
}
